<div class="row">
  <div class="col fw-600 fs-14p">
    {{ 'workspaces.clauseAlignmentMatrix' | transloco }}
  </div>
</div>
<div class="row">
  <div class="col">
    {{
      'workspaces.comparingWorkspaceDocumentsAgainst'
        | transloco: { referenceDocumentName: selectedReferenceDocument?.name }
    }}
  </div>
</div>

<div class="row mt-10p">
  <div class="col">
    @if (reviewDocuments.length) {
      <div class="analyzing-dashboard__occurrence-table">
        <div class="analyzing-dashboard__documents analyzing-dashboard__documents--alignment">
          <div
            class="analyzing-dashboard__header analyzing-dashboard__header--alignment"
            [style.grid-template-columns]="matrixGridTemplateColumns"
          >
            <div>{{ 'workspaces.clause' | transloco }}</div>
            @for (document of reviewDocuments; track document.id) {
              <div
                class="analyzing-dashboard__header-cell analyzing-dashboard__header-cell--document"
                [title]="document.name"
              >
                {{ document.name }}
              </div>
            }
          </div>

          @if (clauseAlignmentRows.length) {
            @for (row of clauseAlignmentRows; track row.clauseId) {
              <div
                class="analyzing-dashboard__row analyzing-dashboard__row--alignment"
                [style.grid-template-columns]="matrixGridTemplateColumns"
              >
                <div class="analyzing-dashboard__cell analyzing-dashboard__cell--alignment-clause">
                  {{ row.clauseName }}
                </div>

                @for (documentStatus of row.documentStatuses; track documentStatus.documentId) {
                  <div class="analyzing-dashboard__cell" [attr.data-label]="documentStatus.documentName">
                    <div
                      class="alignment-matrix__status"
                      [class.alignment-matrix__status--yes]="
                        documentStatus.status === ClauseAlignmentStatus.Yes
                      "
                      [class.alignment-matrix__status--no]="
                        documentStatus.status === ClauseAlignmentStatus.No
                      "
                      [class.alignment-matrix__status--empty]="!documentStatus.status"
                    >
                      @if (documentStatus.status === ClauseAlignmentStatus.Yes) {
                        <span>{{ 'buttons.yes' | transloco }}</span>
                      }

                      @if (documentStatus.status === ClauseAlignmentStatus.No) {
                        <span>{{ 'buttons.no' | transloco }}</span>
                      }

                      @if (!documentStatus.status) {
                        <span>-</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          } @else {
            <div class="analyzing-dashboard__empty">
              {{
                loadingReviewDataComplete
                  ? ('workspaces.noDetailedClauseAlignmentRows' | transloco)
                  : ('workspaces.loadingDetailedClauseAlignment' | transloco)
              }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<div class="row legend">
  <div class="col">
    <span [innerHTML]="'workspaces.legendClauseAlignment' | transloco"></span>
  </div>
</div>
